/**
 * 营运中心--》送货上门
 */

export default {
  print_with_units: ['89238'], // 打印清单和打印预览接口带选中的运单号
  //送货上门单选后不取消其他行选中状态
  home_delivery_service_select_others: ['90100','84645'], // 202601300947384101877
};
